import React, { createContext, useCallback, useState } from "react";

export const SelectContext = createContext();

export const SelectProvider = ({ children }) => {
  const [valuesLength, setValuesLength] = useState({});
  const [options, setOptions] = useState({});

  const changeValue = useCallback((key, val) => {
    setValuesLength((prev) => ({ ...prev, [key]: val }));
  }, []);

  const changeOptions = useCallback((key, val) => {
    setOptions((prev) => ({ ...prev, [key]: val }));
  }, []);

  const clear = useCallback(() => {
    setOptions({});
    setValuesLength({});
  }, []);

  return (
    <SelectContext.Provider
      value={{
        valuesLength,
        changeValue,
        changeOptions,
        options,
        clear,
      }}
    >
      {children}
    </SelectContext.Provider>
  )
};
